module.exports = __webpack_public_path__ + "img/logo.4767b440.png";